<template>
  <div class="outher_se_meal">
    <p class="sub-title package">其他套餐</p>
    <div class="custom-package pr">
      <swiper v-if="comboViewModels.length" class="custom-package-swiper" :options="swiperOption">
        <swiper-slide class="swiper-item" v-for="(item, index) in comboViewModels" :key="index">
          <!-- <van-image class="item-bg" @click="goOther(item.id)" :src="item.mobileImage" alt=""/> -->
          <img class="item-img" :src="item.mobileThumbnail" alt="" @click="goOther(item.id)"/>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: 'combinationOutherSetMeal',

  props: {
    comboViewModels: Array
  },

  data () {
    return {
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },

  methods: {
    goOther (val) {
      this.$emit('changeid', val)
    }
  }
}
</script>

<style lang="less" scoped>
.outher_se_meal{
  width: 100%;
  overflow: hidden;
  padding-bottom: 40px;
  .sub-title {
    position: relative;
    font-size: 30px;
    font-weight: bold;
    line-height: 54px;
    text-align: center;
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      z-index: 1;
      width: 190px;
      height: 4px;
      margin-top: -2px;
      background-color: @second-color;
    }
    &::before {
      left: 20px;
    }
    &::after {
      right: 20px;
    }
    &.package {
      &::before,
      &::after {
        width: 280px;
      }
    }
  }
  .custom-package-swiper {
    width: 950px;
    padding: 22px 0 90px 20px;
    position: static;
    .swiper-item {
      position: relative;
      width: 470px;
      height: 280px;
      border-radius: 8px;
      overflow: hidden;
      .item-img {
        width: 100%;
        height: 100%;
      }
      .item-content {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 1;
        width: 100%;
        box-sizing: border-box;
        padding: 37px 84px 0 50px;
        background-color: rgba(1, 15, 88, .3);
        .item-title {
          font-size: 30px;
          color: #fff;
          line-height: 54px;
        }
        .item-info {
          font-size: 20px;
          line-height: 36px;
          color: rgba(255, 255, 255, .6);
        }
      }
    }
    .swiper-pagination {
      bottom: 45px;
      width: 100%;
    }
  }
  .btn-small {
    display: block;
    width: 150px;
    height: 48px;
    margin-top: 18px;
    border-radius: 6px;
    font-size: 18px;
    text-align: center;
    color: #333;
    line-height: 48px;
    background: url("../../assets/btn_bg.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }
}
</style>
